
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[pillar]/[city]",
      function () {
        return require("private-next-pages/[pillar]/[city]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[pillar]/[city]"])
      });
    }
  